<template>
  <div class="text-13 h-6 flex items-center">Chart</div>
</template>

<script>
export default {
  name: 'ChartOverview',
  props: {
    item: {
      type: Object,
    },
    evaluate: Array,
  },
  computed: {
    variable() {
      return this.payload.variable;
    },
    payload() {
      return this.item.payload;
    },
    isFunction() {
      return this.payload.assignment_type === 'function';
    },
    isExpression() {
      return this.payload.assignment_type === 'function';
    },
    functionName() {
      if (!this.isFunction) return '';
      return this.payload?.value?.function;
    },
    functionArgs() {
      return this.payload.value?.arguments;
    },
    value() {
      return this.payload.value;
    },
  },
  methods: {
    getVariableName(variable) {
      return variable.substring(1).slice(0, -1);
    },
    isVariable(str) {
      if (str) {
        return str.toString().startsWith('{') && str.toString().endsWith('}');
      }
      return false;
    },
  },
};
</script>
